import { useQuery } from "@tanstack/react-query";
import { Axios } from "@/lib/axios";

export interface FeaturePack {
  id: string;
  featureKey: string;
  featureName: string;
  name: string;
  description?: string | null;
  quantity: number;
  price: string; // formatted
  badge?: string | null;
  displayOrder?: number | null;
}

export const usePacks = () => {
  const { data, isLoading, error, refetch } = useQuery<FeaturePack[]>({
    queryKey: ["pricing", "packs"],
    queryFn: async () => {
      const res = await Axios.get("/api/plans/packs");
      return res.data as FeaturePack[];
    },
    staleTime: 60 * 1000,
  });

  return {
    packs: data || [],
    loading: isLoading,
    error: error ? (error as Error).message : null,
    refetch,
  };
};
